



























import {Component, Prop, Vue} from 'vue-property-decorator';
import theme from '../styles/theme.styl';
import {parseDatePreset} from '@/data/train-store';

const ONE_DAY = 1000 * 60 * 60 * 24;
const CONST_TWO_WEEKS = ONE_DAY * 14;

@Component
export default class DateSelector extends Vue {
  @Prop() public date!: string;
  @Prop() public presets!: Array<{ label: string, value: string }>;

  private showPicker = false;
  private dateValue: string;
  private classes = theme;

  constructor() {
    super();
    const {date} = parseDatePreset(this.date);
    this.dateValue = date.toISOString().substr(0, 10);
  }

  private get presetsList() {
    return this.presets.map((x) => {
      const {day} = parseDatePreset(x.value);
      return {
        label: x.label.replace(/{DAY}/g, day),
        selected: x.value === this.date,
        value: x.value
      };
    });
  }

  private get dateLabel() {
    const {day, dateStr} = parseDatePreset(this.date);
    return `${day} ${dateStr}`;
  }

  private onDateChange(dateStr: string) {
    this.showPicker = false;

    const [yearStr, monthStr, dayStr] = dateStr.split('-');
    const date = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
    const hoursFromNow = Math.round((date.getTime() - Date.now()) / (1000 * 60 * 60));
    if (hoursFromNow > CONST_TWO_WEEKS || hoursFromNow < -ONE_DAY) return;

    this.$emit('change', `today+${hoursFromNow}`);
  }
}
